import type {OfferingCreateDraftKey} from "./storage-keys";

export type OfferingCreateDraftScope = {
  draftKey: OfferingCreateDraftKey;
  email: string;
};

/**
 * Builds a sessionStorage key scoped to the logged-in user so drafts do not
 * leak across accounts on the same browser origin.
 */
export function buildOfferingCreateDraftStorageKey({
  draftKey,
  email,
}: OfferingCreateDraftScope): string {
  const normalizedEmail = email.trim().toLowerCase();
  if (!normalizedEmail) {
    throw new Error("Cannot build offering draft storage key without email");
  }

  return `${draftKey}:${normalizedEmail}`;
}
